import React from "react";
import ManIcon from "@mui/icons-material/Man";
import WomanIcon from "@mui/icons-material/Woman";
// import SimpleNegativeMiniChart from "../../charts/barWithNegatives/SimpleNegativeMiniChart";
import CircularProgress from "@mui/material/CircularProgress";

const CamSingleBarChartMiniCard = ({
  title,
  suffix,
  data,
  cardInfoLoader,
  Icon,
}) => {
  const total = data.man + data.woman;
  const manPercentage = (data.man / total) * 100;
  const womanPercentage = (data.woman / total) * 100;

  return (
    <div className="flex flex-col p-2 bg-white shadow-xl h-full w-full rounded-xl">
      <div className="flex">
        <div className="w-[35px] h-[24px] object-contain">
          {typeof Icon === "string" ? (
            <img src={Icon} className="w-full h-full" alt="svg" />
          ) : (
            <Icon sx={{ width: "100%" }} />
          )}
        </div>
        <h2 className="text-lg font-medium text-left font-Roboto">{title}</h2>
      </div>
      {cardInfoLoader ? (
        <CircularProgress color="secondary" />
      ) : (
        <div className="flex items-center justify-center">
          <h3 className="text-3xl font-bold font-Roboto leading-none">
            {Number(data.total).toLocaleString() + suffix}
          </h3>
        </div>
      )}
      <div className="flex flex-row">
        {cardInfoLoader ? (
          <CircularProgress color="secondary" />
        ) : (
          <div className="flex flex-row w-full items-center">
            <div className="flex flex-col items-center font-Roboto text-xs">
              <ManIcon />
              <p>{Number(data.man).toLocaleString() + suffix}</p>
            </div>
            <div className="flex items-center h-full w-full p-1">
              <div className="h-1/2" 
                style={{ width: `${manPercentage}%`, backgroundColor: "#26a0fc" }}
              ></div>
              <div className="h-1/2"
                style={{ width: `${womanPercentage}%`, backgroundColor: "#ff6178" }}
              ></div>
              {/* <SimpleNegativeMiniChart
                  watchersData={{
                    man: data.man,
                    woman: data.woman,
                  }}
                  suffix={suffix}
                /> */}
            </div>
            <div className="flex flex-col items-center font-Roboto text-xs">
              <WomanIcon />
              <p>{Number(data.woman).toLocaleString() + suffix}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CamSingleBarChartMiniCard;
